import { render, staticRenderFns } from "./LawSearch.vue?vue&type=template&id=5acbf312"
import script from "./LawSearch.vue?vue&type=script&lang=js"
export * from "./LawSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports